<template>
  <div class="pg_mod stream plan_stream fs add_edit_mode" aria-label="Plan Stream">
    <template v-if="!isLoading">
      <div class="row page-heading">
        <div class="col-8 input module_heading" role="heading" aria-level="1">
          <span class="module_icon icon-stream"></span>
          <span class="module_type_name">{{stream.title}}</span>
        </div>
        <div class="col-4 submit btn_container" role="group">
          <button class="btn btn-primary" @click.stop="doneClicked" aria-label="done">done</button>
          <button class="btn btn-primary" @click.stop="saveClicked" aria-label="save">save</button>
          <button class="btn btn-primary" @click.stop="cancelClicked">cancel</button>
        </div>
      </div>
      <div class="pg_bar2">
        <div class="course_search_dropdown">
          <b-form-group v-if="showTermSelect && (planStreamSearchType !== this.OTHER_SEARCH)" label="Please Select a Term">
            <b-form-radio-group plain stacked v-model="selectedTermCode" aria-label="selected term code">
              <template v-for="semester in semesters">
                <b-form-radio :value="semester.termCode"><span>{{ semester.academicTerm }}</span></b-form-radio>
              </template>
            </b-form-radio-group>
          </b-form-group>
          <plan-stream-drop-down ref="planStream"
            v-on:search-button-clicked='searchButtonClicked'>
          </plan-stream-drop-down>
        </div>
      </div>
      <div class="pg_content">
        <div class="row pg_content_row">
          <div class="col-8 pg_lft_sec">
            <template v-if="planningSubStreams && planningSubStreams.length === 0">
              <div class="col-11 empty_pattern msg_no_data" style="margin-top: 55px; padding: 76px 0px;">
                No course added in this planning stream
              </div>
            </template>
            <template v-if="planningSubStreams && planningSubStreams.length > 0">
              <!--- course popup -->
              <div class="">
                <b-modal
                  class="alert_popup"
                  ref="confirmRemoveContent"
                  hide-header
                  hide-footer
                  no-close-on-backdrop
                  no-close-on-esc
                  centered>
                  <div class="msg">
                    <div>Are you sure you want to remove this course "<span class="entity_name" v-html="courseToRemove.title"></span>" from planning stream.</div>
                  </div>
                  <div class="btn_container">
                    <b-btn
                      @click.stop.prevent="hideConfirmRemoveContentPopup(), removeActiveClass(courseToRemove.uuid)"
                      aria-label="close active mode">
                      cancel
                    </b-btn>
                    <b-btn
                      @click.stop.prevent='removeCourse(courseToRemove.uuid), removeActiveClass(courseToRemove.uuid), hideConfirmRemoveContentPopup()'
                      aria-label="remove this course from my planning stream">
                      remove
                    </b-btn>
                  </div>
                </b-modal>
              </div>
              <!--- course popup -->
              <!--- catalog popup -->
              <!--
              <div class="">
                <b-modal
                  class="alert_popup"
                  ref="confirmRemoveContent"
                  hide-header
                  hide-footer
                  no-close-on-backdrop
                  no-close-on-esc
                  centered>
                  <div class="msg">
                    <div>Are you sure you want to remove this catalog "<span class="entity_name" v-html="catalogToRemove.title"></span>" from planning stream.</div>
                  </div>
                  <div class="btn_container">
                    <b-btn
                    @click.stop.prevent="hideConfirmRemoveContentPopup(), removeActiveClass(catalogToRemove.uuid)"
                    aria-label="close active mode">
                      cancel
                    </b-btn>
                    <b-btn
                    @click.stop.prevent='removeCatalog(catalogToRemove.uuid), removeActiveClass(catalogToRemove.uuid), hideConfirmRemoveContentPopup()'
                    aria-label="remove this catalog from my planning stream">
                      remove
                    </b-btn>
                  </div>
                </b-modal>
              </div>
              -->
              <!--- job, club, event update popup -->
              <div class="page_content">
                <b-modal ref="confirmAddOtherEntity" size="lg" :header-bg-variant="'light'" no-close-on-backdrop no-close-on-esc centered>
                  <div slot="modal-header" class="header-section">
                    <div class="btn_container">
                       <button class="btn_close" aria-label="close" @click="hideConfirmAddOtherEntityPopup">
                          <span class="ic-close"></span>
                       </button>
                    </div>
                  </div>
                  <div class="mb-4">
                    <template v-if="selectedOtherEntityToEdit">
                      <div style="margin-top: -20px;">Updating "<span v-html="otherEntityTitle"></span>" from Co-Curricular part of your Stream!</div>
                    </template>
                    <template v-else>
                      <div style="margin-top: -20px;">Adding "<span v-html="otherEntityTitle"></span>" to Co-Curricular part of your Stream!</div>
                    </template>
                  </div>
                  <div>
                    <div class="row page_fld_section">
                      <div class="col-5">
                        <div class="mb-2">
                          <span>Status</span>
                        </div>
                        <div>
                          <b-form-select v-model="status" :options="statusOptions"></b-form-select>
                        </div>
                      </div>
                    </div>
                    <div class="row page_fld_section">
                      <div class="col-5">
                        <div class="mb-2">
                          <span>Start Date</span>
                        </div>
                        <div>
                          <span>
                            <datetime
                              type="date" v-model="startDate" input-id="startDate" :week-start="7"
                              :format="{year: 'numeric', month: '2-digit', day: '2-digit'}" auto
                              :min-datetime="minDatetime" input-style="width: 100%; height: 34px;">
                            </datetime>
                          </span>
                        </div>
                      </div>
                      <div class="col-5">
                        <div class="mb-2">
                          <span>End Date</span>
                        </div>
                        <div>
                          <span>
                            <datetime
                              type="date" v-model="endDate" input-id="endDate" :week-start="7"
                              :format="{year: 'numeric', month: '2-digit', day: '2-digit'}" auto
                              :min-datetime="minDatetime" input-style="width: 100%; height: 34px;" :disabled="!startDate">
                            </datetime>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="row page_fld_section">
                      <div class="col-5">
                        <span class="mr-2 align-top">Verified</span>
                        <span>
                          <toggle-button :value="verified" :sync="true" :labels="{checked: 'Yes', unchecked: 'No'}" :width="60" :height="25" :font-size="15" :color="{checked: '#407c45', unchecked: '#8b1c08', disabled: getDisabledColor(verified)}" :disabled="true"/>
                        </span>
                      </div>
                    </div>
                    <div class="row page_fld_section">
                      <div class="col-5" v-if="notifyAdvisor">
                        <span>Advisor Verification Requested</span>
                      </div>
                      <div class="col-5" v-else>
                        <span style="cursor: pointer; color: #157099;" @click="notifyAdvisor = true">Request Advisor for Verification</span>
                      </div>
                    </div>
                  </div>
                  <div slot="modal-footer">
                    <template v-if="selectedOtherEntityToEdit">
                      <b-button variant="primary" size="sm" class="float-right" @click="editOtherEntity">Edit</b-button>
                    </template>
                    <template v-else>
                      <b-button variant="primary" size="sm" class="float-right" @click="addOtherEntity">Add</b-button>
                    </template>
                  </div>
                </b-modal>
              </div>
              <!--- job, club, event update popup -->
              <div class="pg_action">
                <b-btn class="btn_arrow" @click.stop.prevent="scrollContainerToLeft()">
                  <span class="ico-arrow-left2"></span>
                </b-btn>
              </div>
              <div class="cols_container">
                <div class="row cols_container_inner">
                  <template v-for="subStream in planningSubStreams">
                    <b-container class="col-4 cal_col">
                      <b-row class="mod_col_hd">
                        <b-col class="col-11 hd_txt">
                          {{subStream.title}}:
                        </b-col>
                        <b-col class="col-1 ic_container">
                          <b-dropdown right variant="primary" class="fa fa-ellipsis-v more_action" v-if="isScheduleCheckEnabled && hasCourses(subStream)">
                            <b-dropdown-item href="#" @click="goToCalendarView(subStream)" aria-label="check schedule" :disabled="!subStream.courses.length || subStream.courses.length <= 0"> check schedule</b-dropdown-item>
                          </b-dropdown>
                        </b-col>
                      </b-row>
                      <div class="plan_list_section">
                        <template class="course-list-section" v-for="course in subStream.courses">
                          <b-row class="mod_col_row">
                            <b-col>
                              <b-row class="course_class_time" :id="course.uuid" :class="getCourseStyle(course)">
                                <b-col v-if="!courseToRemove || courseToRemove.uuid !== course.uuid" class="course_details" :class="getCourseStyle(course)">
                                  <!--
                                    <span class="icon-course icon"></span>
                                    -->
                                  <span class="course-title" :title="course.title" v-b-tooltip.hover.topright>
                                  {{course.title}}
                                  </span>
                                  <span class="ic" :title="'remove this course from my planning stream'"
                                    v-b-tooltip.hover.topright>
                                    <b-btn @click.stop="courseSelectedForRemoval(course, $event)">
                                      <span class="ico-cross"></span>
                                    </b-btn>
                                  </span>
                                </b-col>
                                <b-col v-else-if="courseToRemove && courseToRemove.uuid === course.uuid" class="course_details" :class="getCourseStyle(course)">
                                  <span class="course-title">
                                  {{course.title}}
                                  </span>
                                  <span class="ic">
                                    <b-btn>
                                      <span class="ico-cross"></span>
                                    </b-btn>
                                  </span>
                                  <!--
                                    <span class="icon_close"
                                      @click.stop.prevent="removeActiveClass"
                                      title="close active mode"
                                      aria-label="close active mode">
                                        {{closeIcon}}
                                    </span>
                                    <div class='remove_course_container'>
                                      <span class="icon-bin2" @click.stop.prevent='removeCourse(course), removeActiveClass(course)' title="remove this course from my planning stream" aria-label="remove this course from my planning stream">
                                      </span>
                                    </div>
                                    -->
                                </b-col>
                              </b-row>
                            </b-col>
                          </b-row>
                        </template>
                        <!-- end course list -->
                        <template class="course-list-section" v-for="catalog in subStream.catalogs">
                          <b-row class="mod_col_row">
                            <b-col>
                              <b-row class="course_class_time" :id="catalog.uuid" :class="getCatalogStyle(catalog)">
                                <b-col v-if="!catalog || catalogToRemove.uuid !== catalog.uuid" class="course_details" :class="getCatalogStyle(catalog)">
                                  <span class="course-title" :title="catalog.title" v-b-tooltip.hover.topright>
                                  {{catalog.title}}
                                  </span>
                                  <span class="ic" :title="'remove this catalog from my planning stream'" v-b-tooltip.hover.topright>
                                    <b-btn @click.stop="catalogSelectedForRemoval(catalog, $event)">
                                      <span class="ico-cross"></span>
                                    </b-btn>
                                  </span>
                                </b-col>
                                <b-col v-else-if="catalogToRemove && catalogToRemove.uuid === catalog.uuid" class="course_details" :class="getCatalogStyle(catalog)">
                                  <span class="course-title">
                                  {{catalog.title}}
                                  </span>
                                  <span class="ic">
                                    <b-btn>
                                      <span class="ico-cross"></span>
                                    </b-btn>
                                  </span>
                                </b-col>
                              </b-row>
                            </b-col>
                          </b-row>
                        </template>
                        <!-- end catalog list -->
                        <template class="course-list-section" v-for="job in subStream.jobs">
                          <b-row class="mod_col_row mb-1" style="background: #f5f5f5;">
                            <b-col>
                              <b-row class="course_class_time job-stream-style" :id="job.uuid">
                                <b-col v-if="!job || jobToRemove.uuid !== job.uuid" class="course_details job-stream-style">
                                  <span class="ico-job2"></span>
                                  <span class="job-title" :title="job.title" v-b-tooltip.hover.topright>
                                  {{job.title}}
                                  </span>
                                  <span class="ic" :title="'remove this job from my planning stream'"
                                    v-b-tooltip.hover.topright>
                                    <b-btn @click.stop="jobSelectedForRemoval(job, $event)">
                                      <span class="ico-cross"></span>
                                    </b-btn>
                                  </span>
                                  <span class="ic" :title="'update status and duration for this job'"
                                    v-b-tooltip.hover.topright v-if="isOwner">
                                    <b-btn @click.stop="jobSelectedForEdit(job, $event)">
                                      <span class="ico-pencil"></span>
                                    </b-btn>
                                  </span>
                                </b-col>
                              </b-row>
                            </b-col>
                          </b-row>
                        </template>
                        <!-- end job list -->
                        <template class="course-list-section" v-for="club in subStream.clubs">
                          <b-row class="mod_col_row mb-1" style="background: #f5f5f5;">
                            <b-col>
                              <b-row class="course_class_time club-stream-style" :id="club.uuid">
                                <b-col v-if="!club || clubToRemove.uuid !== club.uuid" class="course_details club-stream-style">
                                  <span class="ico-club"></span>
                                  <span class="club-title" :title="club.title" v-b-tooltip.hover.topright>
                                  {{club.title}}
                                  </span>
                                  <span class="ic" :title="'remove this club from my planning stream'"
                                    v-b-tooltip.hover.topright>
                                    <b-btn @click.stop="clubSelectedForRemoval(club, $event)">
                                      <span class="ico-cross"></span>
                                    </b-btn>
                                  </span>
                                  <span class="ic" :title="'update status and duration for this club'"
                                    v-b-tooltip.hover.topright v-if="isOwner">
                                    <b-btn @click.stop="clubSelectedForEdit(club, $event)">
                                      <span class="ico-pencil"></span>
                                    </b-btn>
                                  </span>
                                </b-col>
                              </b-row>
                            </b-col>
                          </b-row>
                        </template>
                        <!-- end club list -->
                        <template class="course-list-section" v-for="eventObject in subStream.events">
                          <b-row class="mod_col_row mb-1" style="background: #f5f5f5;">
                            <b-col>
                              <b-row class="course_class_time event-stream-style" :id="eventObject.uuid">
                                <b-col v-if="!eventObject || eventToRemove.uuid !== eventObject.uuid" class="course_details event-stream-style">
                                  <span class="fas fa-calendar-alt"></span>
                                  <span class="event-title" :title="eventObject.title" v-b-tooltip.hover.topright>
                                  {{eventObject.title}}
                                  </span>
                                  <span class="ic" :title="'remove this event from my planning stream'"
                                    v-b-tooltip.hover.topright>
                                    <b-btn @click.stop="eventSelectedForRemoval(eventObject, $event)">
                                      <span class="ico-cross"></span>
                                    </b-btn>
                                  </span>
                                  <span class="ic" :title="'update status and duration for this event'"
                                    v-b-tooltip.hover.topright v-if="isOwner">
                                    <b-btn @click.stop="eventSelectedForEdit(eventObject, $event)">
                                      <span class="ico-pencil"></span>
                                    </b-btn>
                                  </span>
                                </b-col>
                              </b-row>
                            </b-col>
                          </b-row>
                        </template>
                        <!-- end event list -->
                      </div>
                    </b-container>
                  </template>
                  <!-- end module/term/substream -->
                </div>
                <!-- .cols_container_inner -->
              </div>
              <!-- .cols_container -->
              <div class="pg_action">
                <b-btn class="btn_arrow" @click.stop.prevent="scrollContainerToRight()">
                  <span class="ico-arrow-right2"></span>
                </b-btn>
              </div>
            </template>
            <div class="loading-spinner">
              <b-modal style="padding: 0px; overflow: hidden;" ref="loadingModal" ok-disabled cancel-diasbled hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
                <div class="text-center" style="color: #FFF; overflow: hidden;">
                  <div><i class="fa fa-spinner fa-3x fa-fw fa-pulse"></i></div>
                </div>
              </b-modal>
            </div>
          </div>
          <div class="col-4 pg_rgt_sec">
            <b-tabs>
              <b-tab @click="courseSearchTabClicked" title="Courses with term Code" aria-label="courses">
                <div class="pagination">
                  <b-btn class="btn_add" v-if="showAddCourseToStreamButton" @click="addToStreamClicked">
                    add
                  </b-btn>
                  <div class="pg_btn_container btn_container pagination_sty3">
                    <button type="button" class="btn btn_trans" :disabled="first" @click="prevPage" :title="$t('previousPage')" :aria-label="$t('previousPage')"><span class="ic2_arr_pre3" aria-hidden="true"></span></button>
                    <span class="current-page">{{pageNumber}}</span>
                    <button type="button" class="btn btn_trans" :disabled="last" @click="nextPage" :title="$t('nextPage')" :aria-label="$t('nextPage')"><span class="ic2_arr_next3" aria-hidden="true"></span></button>
                  </div>
                </div>
                <template v-if="formattedCourseResults && formattedCourseResults.length === 0">
                  <div class="col-11 empty_pattern msg_no_data" style="margin-top: 55px; padding: 76px 0px;">
                    No course added in this planning stream
                  </div>
                </template>
                <div class="col-12 tab_panel">
                  <template v-if="formattedCourseResults.length > 0" v-for="course in formattedCourseResults">
                    <b-row class="entity_row" :class="course.isAddedToStream ? 'entity_checked' : ''">
                      <b-col cols="1">
                        <input type="checkbox"
                          :checked="isCourseSelected(course)"
                          :disabled="course.isAddedToStream"
                          @input.stop="courseCheckboxSelected(course)"></input>
                      </b-col>
                      <b-col cols="11 course-title">
                        <span class="ic icon-course"></span>
                        <span class="title" @click.stop="navigateToCourse(course)" tabindex="0">
                        {{course.title}}
                        </span>
                      </b-col>
                    </b-row>
                  </template>
                </div>
              </b-tab>
              <b-tab v-if="isPlanStreamCatalogsEnabled" @click="catalogSearchTabClicked" :title="planStreamCatalogsLabel" aria-label="catalogs">
                <div class="pagination btn_container pagination_sty3">
                  <b-btn class="btn_add" v-if="showTermSelect && selectedTermCode && selectedTermCode.length" @click="addEntitiesToStreamClicked">
                    add
                  </b-btn>
                </div>
                <template v-if="formattedCatalogResults && formattedCatalogResults.length === 0">
                  <div class="col-11 empty_pattern msg_no_data" style="margin-top: 55px; padding: 76px 0px;">
                    No catalog added in this planning stream
                  </div>
                </template>
                <div class="col-12 tab_panel">
                  <template v-if="formattedCatalogResults.length > 0" v-for="catalog in formattedCatalogResults">
                    <b-row class="entity_row">
                      <b-col cols="1">
                        <input type="checkbox"
                          :checked="isEntitySelected(catalog)"
                          :disabled="catalog.isAddedToStream"
                          @input.stop="entityCheckboxSelected(catalog)"></input>
                      </b-col>
                      <b-col cols="11">
                        <div class="course-title">
                          <span class="ic ico-catalog"></span>
                          <span class="title"
                            @click.stop="navigateToEntity(catalog)"
                            tabindex="0">
                          {{catalog.title}}
                          </span>
                        </div>
                      </b-col>
                    </b-row>
                  </template>
                </div>
              </b-tab>
              <!-- TODO: make new flag  -->
              <b-tab v-if="isPlanStreamOtherEntitiesEnabled" @click="otherEntitiesSearchTabClicked" :title="planStreamOtherEntitiesLabel" aria-label="entities">
                <div class="pagination float-right btn_container pagination_sty3">
                  <b-form-radio-group plain
                    v-model="selectedSearchIndex"
                    :options="otherSearchIndexes"
                    class="mt-2"
                    ></b-form-radio-group>
                </div>
                <div class="pagination btn_container pagination_sty3">
                  <b-btn class="btn_add" v-if="showAddEntityToStreamButton" @click="addOtherEntityToStreamClicked">add</b-btn>
                </div>
                <div class="col-12 tab_panel">
                  <template v-if="formattedOtherEntitiesResults.length > 0" v-for="entity in formattedOtherEntitiesResults">
                    <b-row class="entity_row">
                      <b-col cols="1">
                        <input type="radio"
                          :value="entity"
                          name="otherEntityRadio"
                          v-model="otherEntitySelectedValue"
                          :disabled="entity.isAddedToStream"
                          @change="entityCheckboxSelected(entity)"
                        ></input>
                      </b-col>
                      <b-col cols="11" class="course-title">
                        <div class="ic" :class="getEntityClass(entity)"></div>
                        <div class="title"
                          @click.stop="navigateToEntity(entity)"
                          tabindex="0">
                        {{entity.title}}
                        </div>
                      </b-col>
                    </b-row>
                  </template>
                </div>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
  import { mapState, mapActions } from 'vuex'
  import { DateTime } from 'luxon'
  import { Datetime } from 'vue-datetime'
  import 'vue-datetime/dist/vue-datetime.css'
  import { PACKAGE } from '../../../package_constants'
  import { PackageUtil } from '../../../package_utils'
  import PlanStreamDropDown from '../../stream/components/PlanStreamDropDown'
  import '../../../assets/module/css/stream/streamPlanner.min.css'
  import '../../../assets/module/css/semester/calendarView.min.css'
  import '../../../assets/module/css/discover/courseSearch.min.css'

  export default {
    name: 'planStream',
    props: ['uuid', 'academicYear'],
    components: {
      Datetime,
      PlanStreamDropDown
    },
    data: () => {
      return {
        isLoading: true,
        showConfirmPopup: false,
        userObject: JSON.parse(localStorage.getItem('userobj')),
        userId: localStorage.getItem('userid'),
        userRole: localStorage.getItem('userrole'),
        academicYearDefault: '2019-2020',
        searchTerms: '',
        courseToRemove: {},
        catalogToRemove: {},
        jobToRemove: {},
        clubToRemove: {},
        eventToRemove: {},
        lastClickedCell: {},
        courseSearchIndexes: ['deliverycontext'],
        catalogSearchIndexes: ['catalog'],
        otherSearchIndexes: ['job', 'club', 'event'],
        selectedSearchIndex: '',
        otherEntitiesSemesterMap: {'JOB': 'My Jobs', 'CLUB': 'My Clubs', 'EVENT': 'My Events'},
        allFolders: [],
        foldersSelected: [],
        selectedFacetNames: [],
        facetFieldMap: {
          facetedCourseTags: 'facetedCourseTags.tagNames',
          catalogCourseDepartment: 'department',
          catalogCourseSubject: 'subject',
          catalogCourseDivision: 'division',
          catalogCourseInstructor: 'instructorNames',
          catalogCourseCredit: 'creditHour',
          catalogCourseTime: 'timeSlots',
          catalogCourseFlag: 'courseFlags',
          catalogCourseLevel: 'level',
          catalogCourseBlock: 'block',
          catalogCourseGradeLevel: 'gradeLevel',
          catalogCourseYear: 'academicYear',
          catalogCourseTerm: 'academicTerm'
        },
        filter: {},
        selectedCourses: [],
        selectedCatalogs: [],
        selectedJobs: [],
        selectedClubs: [],
        selectedEvents: [],
        selectedOtherEntities: [],
        courseResults: [],
        size: 50, // NOTE: no page size options for this page.,
        ADVISOR_ROLE: 'Advisor',
        COURSE_SEARCH: 'COURSE',
        CATALOG_SEARCH: 'CATALOG',
        OTHER_SEARCH: 'OTHER',
        catalogSource: [
          'uuid',
          'title',
          'description',
          'creationTime',
          'lastUpdatedTime',
          'type',
          'ancestor',
          'owningLibraryId',
          'ownerName',
          'ownerId',
          'originUuid',
          'thumbnailURIList',
          'appliedTagMap',
          'facetedCourseTags',
          'maxSeats',
          'currentSeats',
          'roomInformation',
          'meetingDays',
          'meetingFromTime',
          'meetingToTime',
          'specialInstructions',
          'crn',
          'division',
          'department',
          'departmentCode',
          'subject',
          'subjectCode',
          'level',
          'maxCredit',
          'minCredit',
          'creditHour',
          'prerequisites',
          'corequisities',
          'catalogCourseId',
          'instructorNames',
          'num',
          'meetingDaysRaw',
          'meetingDaysFormatted',
          'termCode',
          'timeSlots',
          'courseFlags',
          'catalogId',
          'courseMajors',
          'courseMajorCodes',
          '_score'
        ],
        otherEntitiesSource: [
          'uuid',
          'title',
          'type',
          'description',
          'creationTime',
          'lastUpdatedTime',
          '_score'
        ],
        COURSE: 'deliverycontext',
        CATALOG: 'catalog',
        JOB: 'job',
        CLUB: 'club',
        EVENT: 'event',
        selectedTermCode: '',
        ALL_YEARS_CODE: 'ALL',
        ALL_TERMS_CODE: 'ALL',
        first: true,
        last: false,
        status: 'planned',
        statusOptions: ['planned', 'in-progress', 'completed'],
        startDate: null,
        endDate: null,
        notifyAdvisor: false,
        verified: false,
        otherEntityTitle: '',
        otherEntitySelectedValue: null,
        selectedOtherEntityToEdit: null,
        minDatetime: DateTime.utc().toISO()
      }
    },

    created () {
      this.showLoader()
    },

    async mounted () {
      await this.setupUserLibraries()
      await this.loadInstitutionDetail()
      await this.loadInstitutionPackage({uuid: this.userObject.institutionId, isAggregated: false})
      await this.loadPlanningStreamAndCourses()
      await this.initializeSearchFilter()
    },

    updated () {
    },

    methods: {
      ...mapActions([
        'loadLogDashboardActivity',
        'loadStreamPlannerView',
        'loadStreamDetail',
        'updateSelectedStream',
        'populateAllStreamCourses',
        'removeCourseFromStream',
        'removeCatalogFromStream',
        'removeFromStream',
        'loadLibraryPositionMapping',
        'refreshAdvancedSearchResults',
        'executeAdvancedSearch',
        'executeSearchNoFacets',
        'refreshCatalogSearchResults',
        'executeCatalogSearch',
        'loadAllLibraryForUser',
        'loadInstitutionDetail',
        'loadInstitutionPackage',
        'addToMyStream',
        'updatePageNumber',
        'updateFrom',
        'updateSearchAcademicYear',
        'setPlanStreamSearchType',
        'editEntityInStream'
      ]),

      async loadPlanningStreamAndCourses () {
        let streamUuid = this.uuid
        this.loadStreamDetail(streamUuid)
        this.updateSelectedStream({streamUuid: streamUuid})
        this.loadLogDashboardActivity({action: 'viewStreamPlannerView', page: 'streamPlannerView', link: '', entityUuid: streamUuid})
        return this.populateAllStreamCourses({streamUuid: streamUuid})
      },

      goToStreamView () {
        if (this.isPlannerViewEnabled === true) {
          this.loadLogDashboardActivity({action: 'clickPlannerView', page: this.active + 'View', link: 'Planner View', entityUuid: this.uuid})
          return this.$router.push({ name: 'streamPlanner', params: { uuid: this.uuid } })
        }
        this.loadLogDashboardActivity({action: 'clickTimeView', page: this.active + 'View', link: 'Time View', entityUuid: this.uuid})
        return this.$router.push({ name: 'streamTime', params: { uuid: this.uuid } })
      },

      cancelClicked () {
        this.goToStreamView()
      },

      doneClicked () {
        this.goToStreamView()
      },

      saveClicked () {
        this.goToStreamView()
      },

      clearLastClickedCell () {
        // remove the target id from any existing elements to display the popover
        // on the correct element
        let existingPopover = this.lastClickedCell
        if (existingPopover && existingPopover.setAttribute) {
          existingPopover.setAttribute('id', '')
        }
      },

      courseSelectedForRemoval (course, event) {
        this.clearLastClickedCell()
        this.courseToRemove = course
        this.showConfirmRemoveContentPopup()
      },

      catalogSelectedForRemoval (catalog, event) {
        this.clearLastClickedCell()
        this.catalogToRemove = catalog
        this.showConfirmRemoveContentPopup()
      },

      jobSelectedForRemoval (job, event) {
        this.clearLastClickedCell()
        this.jobToRemove = job
        this.removeEntity(job)
      },

      jobSelectedForEdit (job, event) {
        this.selectedOtherEntityToEdit = job
        this.showConfirmAddOtherEntityPopup(job)
      },

      clubSelectedForRemoval (club, event) {
        this.clearLastClickedCell()
        this.clubToRemove = club
        this.removeEntity(club)
      },

      clubSelectedForEdit (club, event) {
        this.selectedOtherEntityToEdit = club
        this.showConfirmAddOtherEntityPopup(club)
      },

      eventSelectedForRemoval (eventObject, event) {
        this.clearLastClickedCell()
        this.eventToRemove = eventObject
        this.removeEntity(eventObject)
      },

      eventSelectedForEdit (eventObject, event) {
        this.selectedOtherEntityToEdit = eventObject
        this.showConfirmAddOtherEntityPopup(eventObject)
      },

      isCourseSelected (course) {
        return this.selectedCourses.includes(course) || course.isAddedToStream
      },

      isEntitySelected (entity) {
        let isSelected = false
        let selectedEntities = [this.selectedCatalogs, this.selectedJobs, this.selectedClubs, this.selectedEvents]
        selectedEntities.forEach(selectedEntityList => {
          if (selectedEntityList && selectedEntityList.includes(entity)) {
            isSelected = true
          }
        })
        return isSelected
      },

      courseCheckboxSelected (course) {
        if (!this.isCourseSelected(course)) {
          this.selectedCourses.push(course)
        } else {
          const courseId = course.uuid
          this.selectedCourses = this.selectedCourses.filter(c => c.uuid !== courseId)
        }
      },

      entityCheckboxSelected (entity) {
        let type = entity.type
        if (!type) {
          return
        }
        type = type.toLowerCase()
        if (!this.isEntitySelected(entity)) {
          if (type === this.CATALOG) {
            this.selectedCatalogs.push(entity)
          }
          if (type === this.JOB) {
            this.selectedJobs = []
            this.selectedJobs.push(entity)
          }
          if (type === this.CLUB) {
            this.selectedClubs = []
            this.selectedClubs.push(entity)
          }
          if (type === this.EVENT) {
            this.selectedEvents = []
            this.selectedEvents.push(entity)
          }
        } else {
          const entityId = entity.uuid
          if (type === this.CATALOG) {
            this.selectedCatalogs = this.selectedCatalogs.filter(c => c.uuid !== entityId)
          }
          if (type === this.JOB) {
            this.selectedJobs = this.selectedJobs.filter(c => c.uuid !== entityId)
          }
          if (type === this.CLUB) {
            this.selectedClubs = this.selectedClubs.filter(c => c.uuid !== entityId)
          }
          if (type === this.EVENT) {
            this.selectedEvents = this.selectedEvents.filter(c => c.uuid !== entityId)
          }
        }
      },

      navigateToCourse (course) {
        return this.$router.push({ name: 'courseDetail', params: { uuid: course.uuid } })
      },

      navigateToEntity (entity) {
        let type = entity.type
        if (!type) {
          return
        }
        type = type.toLowerCase()
        let pageName
        if (!type || type === this.CATALOG) {
          pageName = 'catalogDetail'
        }
        if (!type || type === this.JOB) {
          pageName = 'jobHome'
        }
        if (type === this.CLUB) {
          pageName = 'clubDetail'
        }
        if (type === this.EVENT) {
          pageName = 'eventDetail'
        }
        return this.$router.push({ name: pageName, params: { uuid: entity.uuid } })
      },

      setActiveClass (course) {
        $('.course_class_time').removeClass('active')
        $('#' + course.uuid).addClass('active')
      },

      removeActiveClass () {
        $('.course_class_time').removeClass('active')
        this.clearObjectsToRemove()
      },

      scrollContainerToLeft () {
        /* var columnWidth = $('.cal_col').width()
        var scrollPosition = $('.cols_container').scrollLeft()
        console.log('columnWidth ' + columnWidth)
        console.log('scrollPosition ' + scrollPosition) */
        $('.cols_container').animate({ scrollLeft: '-=300' }, 800)
      },

      scrollContainerToRight () {
        /* var columnWidth = $('.cal_col').width()
        var scrollPosition = $('.cols_container').scrollLeft()
        console.log('columnWidth ' + columnWidth)
        console.log('scrollPosition ' + scrollPosition) */
        $('.cols_container').animate({ scrollLeft: '+=300' }, 800)
      },

      clearObjectsToRemove () {
        this.courseToRemove = {}
        this.catalogToRemove = {}
        this.jobToRemove = {}
        this.clubToRemove = {}
        this.eventToRemove = {}
      },

      clearSelectedObjects () {
        this.selectedCatalogs = []
      },

      clearOtherEntitySelectedObjects () {
        this.selectedJobs = []
        this.selectedClubs = []
        this.selectedEvents = []
        this.startDate = null
        this.endDate = null
        this.notifyAdvisor = false
        this.verified = false
        this.otherEntityTitle = ''
        this.status = 'planned'
        this.otherEntitySelectedValue = null
        this.selectedOtherEntityToEdit = null
      },

      getEntityClass (entity) {
        let type = entity.type
        type = type.toLowerCase()
        if (type === this.JOB) {
          return 'ico-job2'
        }
        if (type === this.CLUB) {
          return 'ico-club'
        }
        if (type === this.EVENT) {
          return 'fas fa-calendar-alt'
        }
      },

      notifySuccess (text) {
        this.$notify({
          group: 'notify',
          type: 'success',
          title: '',
          text: text
        })
      },

      notifyFailure (text) {
        this.$notify({
          group: 'notify',
          type: 'error',
          title: '',
          text: text
        })
      },

      notifyWarning (text) {
        this.$notify({
          group: 'notify',
          type: 'warning',
          title: '',
          text: text
        })
      },

      async removeCourse () {
        let courseToRemove = this.courseToRemove
        if (!courseToRemove) {
          return
        }
        const params = {
          streamUuid: this.uuid,
          currentYear: this.currentYear,
          currentSemester: this.currentSemester,
          courseData: { uuid: courseToRemove.uuid },
          entityType: this.COURSE,
          userRole: this.userRole
        }
        await this.removeCourseFromStream(params)
        this.notifySuccess('Successfully removed \'' + courseToRemove.title + '\' from your stream.')
        this.clearObjectsToRemove()
        // NOTE: The backend updates the course's hasConflict status, so we make another call to reflect this here
        // in the UI's color
        return this.populateAllStreamCourses({streamUuid: this.uuid})
      },

      async removeCatalog () {
        let catalogToRemove = this.catalogToRemove
        if (!catalogToRemove) {
          return
        }
        const params = {
          streamUuid: this.uuid,
          currentYear: this.currentYear,
          currentSemester: this.currentSemester,
          courseData: { uuid: catalogToRemove.uuid },
          entityType: this.CATALOGE,
          userRole: this.userRole
        }
        await this.removeCatalogFromStream(params)
        this.notifySuccess('Successfully removed \'' + catalogToRemove.title + '\' from your stream.')
        this.clearObjectsToRemove()
        // NOTE: The backend updates the course's hasConflict status, so we make another call to reflect this here
        // in the UI's color
        return this.populateAllStreamCourses({streamUuid: this.uuid})
      },

      async removeEntity (entityToRemove) {
        // TODO generify
        if (!entityToRemove || !entityToRemove.uuid) {
          return
        }
        this.$refs.loadingModal.show()
        let isOtherEntities = false
        let entityType = entityToRemove.type.toLowerCase()
        if ((entityType === this.JOB) || (entityType === this.CLUB) || (entityType === this.EVENT)) {
          isOtherEntities = true
        }
        let academicTerm = (isOtherEntities) ? this.otherEntitiesSemesterMap[entityToRemove.termCode] : this.semesterMap[entityToRemove.termCode]
        let currentSemester = (isOtherEntities) ? academicTerm : academicTerm.split(' ')[0]
        let currentYear = (isOtherEntities) ? academicTerm : academicTerm.split(' ')[1]
        const params = {
          streamUuid: this.uuid,
          currentYear: currentYear,
          currentSemester: currentSemester,
          objectData: {uuid: entityToRemove.uuid},
          entityType: entityType,
          userRole: this.userRole
        }
        let resp = await this.removeFromStream(params)
        if (resp) {
          this.notifySuccess('Successfully removed "' + entityToRemove.title + '" ' + entityType + ' from your stream.')
          this.clearObjectsToRemove()
          await this.populateAllStreamCourses({streamUuid: this.uuid})
          this.$refs.loadingModal.hide()
        }
      },

      async addOtherEntity () {
        this.$refs.loadingModal.show()
        if ((this.planStreamSearchType === this.OTHER_SEARCH) && (!this.selectedTermCode || !this.selectedTermCode.length)) {
          this.selectedTermCode = this.selectedSearchIndex.toUpperCase()
        }
        this.loadLogDashboardActivity({action: 'addOtherEntityToStream', page: 'planStream', link: 'add to stream'})
        let entity = this.otherEntitySelectedValue
        await this.addEntityToStream(entity, true)
        // this.clearOtherEntitySelectedObjects()
        this.$forceUpdate()
        this.hideConfirmAddOtherEntityPopup()
        this.$refs.loadingModal.hide()
      },

      async editOtherEntity () {
        this.$refs.loadingModal.show()
        let entityToEdit = this.selectedOtherEntityToEdit
        let entityType = entityToEdit.type.toLowerCase()
        let academicTerm = this.otherEntitiesSemesterMap[entityToEdit.termCode]
        let currentSemester = academicTerm
        let currentYear = academicTerm
        const params = {
          streamUuid: this.uuid,
          currentYear: currentYear,
          currentSemester: currentSemester,
          objectData: {uuid: entityToEdit.uuid, status: this.status, startDate: this.startDate, endDate: this.endDate, notifyAdvisor: this.notifyAdvisor},
          entityType: entityType
        }
        let resp = await this.editEntityInStream(params)
        if (resp) {
          this.notifySuccess('Successfully updated "' + entityToEdit.title + '" ' + entityType + '.')
          await this.populateAllStreamCourses({streamUuid: this.uuid})
        }
        this.hideConfirmAddOtherEntityPopup()
        this.$refs.loadingModal.hide()
      },

      getCourseStyle (course) {
        return course.hasConflict ? 'conflict' : 'no-conflict'
      },

      getCatalogStyle (catalog) {
        return catalog.hasConflict ? 'conflict' : 'no-conflict'
      },

      searchButtonClicked (event) {
        this.searchTerms = event
        this.executeSearch()
      },

      updateCourseSearchResults () {
        console.log('updateCourseSearchResults')
      },

      async initializeSearchFilter () {
        let filter = this.filter
        Object.values(this.facetFieldMap).forEach(fieldName => {
          filter[fieldName] = []
        })
        return filter
      },

      executeSearch (resetFacets) {
        let planStreamSearchType = this.planStreamSearchType
        if (!planStreamSearchType || !planStreamSearchType.length) {
          // default to Course Search
          this.courseSearchTabClicked()
          return this.doCourseSearch(resetFacets)
        }
        if (planStreamSearchType === this.COURSE_SEARCH) {
          return this.doCourseSearch(resetFacets)
        }
        if (planStreamSearchType === this.CATALOG_SEARCH) {
          return this.doCatalogSearch(resetFacets)
        }
        if (planStreamSearchType === this.OTHER_SEARCH) {
          if (!this.selectedSearchIndex || !this.selectedSearchIndex.length) {
            this.selectedSearchIndex = 'job'
          } else {
            return this.doOtherEntitiesSearch()
          }
        }
      },

      doCourseSearch (resetFacets) {
        // construct facets
        let buildFacet = this.buildFacet
        // let getFacetFilter = this.getFacetFilter
        let facets = {
          'facetedCourseTags': buildFacet('facetedCourseTags.tagNames.keyword', 100, 'facetedCourseTags.tagNames'),
          'catalogCourseDivision': buildFacet('division', 100, 'catalogCourseDivision'),
          'catalogCourseDepartment': buildFacet('department', 100, 'catalogCourseDepartment'),
          'catalogCourseSubject': buildFacet('subject', 100, 'catalogCourseSubject'),
          'catalogCourseInstructor': buildFacet('instructorNames', 100, 'catalogCourseInstructor'),
          'catalogCourseCredit': buildFacet('creditHour.keyword', 100, 'catalogCourseCredit'),
          'catalogCourseTime': buildFacet('timeSlots.keyword', 100, 'catalogCourseTime', {'_key': 'desc'}),
          'catalogCourseFlag': buildFacet('courseFlags.keyword', 100, 'catalogCourseFlag'),
          'catalogCourseLevel': buildFacet('level.keyword', 50, 'catalogCourseLevel'),
          'catalogCourseBlock': buildFacet('block', 50, 'catalogCourseBlock'),
          'catalogCourseGradeLevel': buildFacet('gradeLevel.keyword', 50, 'catalogCourseGradeLevel'),
          'catalogCourseYear': buildFacet('academicYear', 50, 'catalogCourseYear'),
          'catalogCourseTerm': buildFacet('academicTerm', 50, 'catalogCourseTerm')
        }

        let filter = this.filterForQuery()
        let loadSearchResults = resetFacets === true ? this.refreshAdvancedSearchResults : this.executeAdvancedSearch
        const searchInput = {
          source: this.formattedSource,
          from: this.from,
          size: this.size,
          indexList: this.formattedIndexList,
          libraryList: this.formattedLibraryList,
          privateLibraryList: this.privateLibraryList,
          publicLibraryList: this.publicLibraryList,
          userId: this.userId,
          facets: facets,
          filter: filter
        }
        loadSearchResults(searchInput).then(response => {
          setTimeout(() => {
            this.hideLoader()
          }, 1000)
        })

        // refresh :disabled state because of Vue binding error for booleans on :disabled
        this.isLastPage()
        this.isFirstPage()
      },

      doCatalogSearch (resetFacets) {
        let buildFacet = this.buildFacet
        let facets = {
          'library': {
            'aggs': {
              'termObj': {
                'terms': {
                  'field': 'owningLibraryId.keyword',
                  'size': 100
                }
              }
            },
            'filter': this.getFacetFilter('owningLibraryId')
          },
          'facetedCourseTags': buildFacet('facetedCourseTags.tagNames.keyword', 100, 'facetedCourseTags.tagNames'),
          'catalogCourseDivision': buildFacet('division', 100, 'catalogCourseDivision'),
          'catalogCourseDepartment': buildFacet('department', 100, 'catalogCourseDepartment'),
          'catalogCourseSubject': buildFacet('subject', 100, 'catalogCourseSubject'),
          'catalogCourseInstructor': buildFacet('instructorNames', 100, 'catalogCourseInstructor'),
          'catalogCourseCredit': buildFacet('creditHour.keyword', 100, 'catalogCourseCredit'),
          'catalogCourseTime': buildFacet('timeSlots.keyword', 100, 'catalogCourseTime', {'_key': 'desc'}),
          'catalogCourseFlag': buildFacet('courseFlags.keyword', 100, 'catalogCourseFlag'),
          'catalogCourseGradeLevel': buildFacet('gradeLevel.keyword', 50, 'catalogCourseGradeLevel')
        }

        let filter = this.filterForQuery()
        const params = {
          source: this.formattedSource,
          from: this.from,
          size: this.size,
          indexList: this.formattedIndexList,
          libraryList: this.formattedLibraryList,
          privateLibraryList: this.privateLibraryList,
          publicLibraryList: this.publicLibraryList,
          userId: this.userId,
          facets: facets,
          filter: filter
        }
        let loadSearchResults = resetFacets === true ? this.refreshCatalogSearchResults : this.executeCatalogSearch
        loadSearchResults(params).then(response => {
          setTimeout(() => {
            this.hideLoader()
          }, 1000)
        })
      },

      doOtherEntitiesSearch () {
        let facets = {
          'library': {
            'aggs': {
              'termObj': {
                'terms': {
                  'field': 'owningLibraryId.keyword',
                  'size': 100
                }
              }
            }
          },
          'filter': this.getFacetFilter('owningLibraryId')
        }
        let filter = this.filterForQuery()
        const params = {
          source: this.formattedSource,
          from: this.from,
          size: this.size,
          indexList: this.formattedIndexList,
          libraryList: this.formattedLibraryList,
          privateLibraryList: this.privateLibraryList,
          publicLibraryList: this.publicLibraryList,
          userId: this.userId,
          facets: facets,
          filter: filter
        }
        let loadSearchResults = this.executeSearchNoFacets // TODO resetFacets always?
        loadSearchResults(params).then(response => {
          setTimeout(() => {
            this.hideLoader()
          }, 1000)
        })
      },

      buildFacet (field, size, facetName, order) {
        return {
          'aggs': {
            'termObj': {
              'terms': {
                'field': field,
                'size': size,
                'order': order || {'_key': 'asc'}
              }
            }
          },
          'filter': this.getFacetFilter(facetName)
        }
      },

      getFacetFilter (facetName) {
        let facetFilterObj = {
          'bool': this.originUuidCheck()
        }
        facetFilterObj.bool['must'] = []
        if (this.filter && facetName && !this.selectedFacetNames.includes(facetName)) {
          // facetFilterObj['and'] = facetFilterObj['and'].concat(this.filterForQuery())
          facetFilterObj.bool['must'] = facetFilterObj.bool['must'].concat(this.filterForQuery())
        }
        return facetFilterObj
      },

      originUuidCheck () {
        let originUuidCheck = {
          'must_not': {
            'exists': {
              'field': 'originUuid'
            }
          }
        }
        return originUuidCheck
      },

      buildFilterTermClause (arrayName, array) {
        let clause = {
          'terms': {}
        }
        clause.terms[arrayName] = array
        return clause
      },

      filterForQuery () {
        let formattedFilter = []
        let filter = this.filter
        let buildTermClause = this.buildFilterTermClause
        Object.keys(filter).forEach(key => {
          let array = filter[key]
          if (array && array.length > 0) {
            formattedFilter.push(buildTermClause(key, array))
          }
        })
        return formattedFilter
      },

      resetUserLibraries () {
        this.folders = []
        this.allFolders = []
        this.foldersSelected = []
        this.publicLibraryList = []
        this.privateLibraryList = []
      },

      async setupUserLibraries () {
        this.showLoader()
        this.loadLibraryPositionMapping()
        this.resetUserLibraries()
        let libraries = await this.loadAllLibraryForUser()
        let learningSpaces = await this.sortLibrariesIntoStandardOrder(libraries)
        if (!learningSpaces || !learningSpaces.length) {
          return
        }
        let userPreferences = this.userObject.userPreferences
        let selectedLearningSpaces = userPreferences ? userPreferences.learningSpaces : []
        learningSpaces.forEach(learningSpace => {
          const category = learningSpace.category
          if (category === 'Institute_Public') {
            this.folders.push({value: learningSpace.uuid, text: learningSpace.displayName + '[0]'})
            this.allFolders.push(learningSpace.uuid)
            if (selectedLearningSpaces.includes(learningSpace.uuid)) {
              this.foldersSelected.push(learningSpace.uuid)
            }
            if (category !== 'Institute' && category !== 'User_Private') {
              this.publicLibraryList.push(learningSpace.uuid)
            }
            if (category === 'User_Private') {
              this.privateLibraryList.push(learningSpace.uuid)
            }
          }
        })
        this.executeSearch()
      },

      async sortLibrariesIntoStandardOrder (libraries) {
        let sortedLibraryList = []
        for (let attr in this.libraryPositionMapping) {
          let value = this.libraryPositionMapping[attr]
          for (let i = 0; i < libraries.length; i++) {
            let library = libraries[i]
            if (await this.libraryMatches(library, value)) {
              sortedLibraryList.push(library)
            }
          }
        }
        return sortedLibraryList
      },

      async libraryMatches (library, value) {
        if (library.category === 'LearningSpace') {
          if (library.title === 'Shared With Me') {
            if (value === 'Shared') {
              return true
            }
          } else {
            if (value === 'Global') {
              return true
            }
          }
        }
        return library.category.indexOf(value) !== -1
      },

      getFormattedDayAndTimeStrings (course) {
        let days = ''
        let times = ''

        if (course.meetingDaysRaw) {
          course.meetingDaysRaw.forEach(function (meetingDay) {
            days += (meetingDay.day) ? (meetingDay.day + '; ') : ''
            times += (meetingDay.meetingFromTime) ? (meetingDay.meetingFromTime + ' - ' + meetingDay.meetingToTime + '; ') : ''
          })
        }
        return {days: days, times: times}
      },

      isCourseInStream (course) {
        let isInStream = false
        let streamCourses = this.semesterCourses
        streamCourses.forEach((streamCourse) => {
          if (course.uuid === streamCourse.uuid) {
            isInStream = true
          }
        })
        return isInStream
      },

      isEntityInStream (targetEntity, entityType) {
        let isInStream = false
        let planningSubStreams = this.planningSubStreams
        if (!planningSubStreams || !planningSubStreams.length || !entityType || !entityType.length) {
          return false
        }
        let entityListName = entityType + 's'
        let selectedTermCode = this.selectedTermCode
        planningSubStreams.forEach(substream => {
          if (substream.termCode === selectedTermCode) {
            let entityList = substream[entityListName]
            if (entityList && entityList.length) {
              entityList.forEach(entity => {
                if (entity.uuid === targetEntity.uuid) {
                  isInStream = true
                }
              })
            }
          }
        })
        return isInStream
      },

      showLoader () {
        this.isLoading = true
        this.$parent.$refs.loadingModal.show()
      },

      hideLoader () {
        this.$parent.$refs.loadingModal.hide()
        this.isLoading = false
      },

      showConfirmRemoveContentPopup () {
        this.showConfirmPopup = true
        if (this.$refs.confirmRemoveContent) {
          this.$refs.confirmRemoveContent.show()
        }
      },

      hideConfirmRemoveContentPopup () {
        this.showConfirmPopup = false
        if (this.$refs.confirmRemoveContent) {
          this.$refs.confirmRemoveContent.hide()
        }
      },

      setStatusAndDuration (entity) {
        if (entity) {
          if (entity.status) {
            this.status = entity.status
          } else {
            this.status = 'planned'
          }
          this.otherEntityTitle = entity.title
          this.startDate = entity.startDate
          this.endDate = entity.endDate
          this.notifyAdvisor = entity.notifyAdvisor
          this.verified = entity.verified
        }
      },

      showConfirmAddOtherEntityPopup (entity) {
        this.setStatusAndDuration(entity)
        if (this.$refs.confirmAddOtherEntity) {
          this.$refs.confirmAddOtherEntity.show()
        }
      },

      hideConfirmAddOtherEntityPopup () {
        this.clearOtherEntitySelectedObjects()
        if (this.$refs.confirmAddOtherEntity) {
          this.$refs.confirmAddOtherEntity.hide()
        }
      },

      async addOtherEntityToStreamClicked () {
        this.otherEntityTitle = this.otherEntitySelectedValue.title
        this.showConfirmAddOtherEntityPopup()
      },

      joinListWithCommas (stringList) {
        let str = []

        for (var i = 0; i < stringList.length; i++) {
          if (str.length === 0) {
            str = stringList[i]
          } else {
            str = str + ',' + stringList[i]
          }
        }
        return str
      },

      getCoursePlanningPackage () {
        let packages = this.packages
        if (!packages || !packages.length || packages.length <= 0) {
          return {}
        }
        return PackageUtil.getCoursePlanningPackage(packages)
      },

      async addCourseToStream (course) {
        // NOTE: Vue.js will not rebind isAddedToStream to :disabled unless we force an update
        // even though this was added in a computed property.
        course.isAddedToStream = true

        let currentSemester = course.academicTerm.split(' ')[0]
        let currentYear = course.academicTerm.split(' ')[1]
        let termCode = this.semesterCodeMap[course.academicTerm]
        const params = {
          streamUuid: this.uuid,
          courseData: { uuid: course.uuid, title: course.title },
          currentSemester: currentSemester,
          currentYear: currentYear,
          termCode: termCode,
          entityType: this.COURSE,
          userRole: this.userRole
        }
        let response = await this.addToMyStream(params)
        if (response) {
          this.notifyWarning('Schedule Conflict! \'' + course.title + '\' conflicts with one or more courses in your stream.')
        }
      },

      async addToStreamClicked () {
        this.loadLogDashboardActivity({action: 'addCourseToStream', page: 'planStream', link: 'add to stream'})

        // NOTE: null check already guarded by computed 'showAddCourseToStreamButton'
        let addCourseToStream = this.addCourseToStream
        let selectedCourses = this.selectedCourses
        await selectedCourses.forEach(course => {
          addCourseToStream(course)
        })
        this.selectedCourses = []
        // avoid any race conditions by forcing the vuex state update
        await this.populateAllStreamCourses({streamUuid: this.uuid, updateTimeStamp: true})
        this.$forceUpdate()
      },

      async addEntityToStream (entity, isCoCurricular) {
        let selectedTermCode = this.selectedTermCode
        if (!selectedTermCode || !selectedTermCode.length) {
          return this.notifyFailure('No term selected. Please select a term and try again')
        }

        let type = entity.type
        if (!type) {
          return this.notifyFailure('Error: \'' + entity.title + '\' data is missing or deleted')
        }
        type = type.toLowerCase()

        let academicTerm = (this.planStreamSearchType === this.OTHER_SEARCH) ? this.otherEntitiesSemesterMap[selectedTermCode] : this.semesterMap[selectedTermCode]

        if (this.isEntityInStream(entity, type)) {
          return this.notifyFailure('\'' + entity.title + '\' is already in \'' + academicTerm + '\'')
        }
        let currentSemester = (this.planStreamSearchType === this.OTHER_SEARCH) ? academicTerm : academicTerm.split(' ')[0]
        let currentYear = (this.planStreamSearchType === this.OTHER_SEARCH) ? academicTerm : academicTerm.split(' ')[1]
        const params = {
          streamUuid: this.uuid,
          data: (isCoCurricular) ? {uuid: entity.uuid, title: entity.title, status: this.status, startDate: this.startDate, endDate: this.endDate, notifyAdvisor: this.notifyAdvisor} : {uuid: entity.uuid, title: entity.title},
          currentSemester: currentSemester,
          currentYear: currentYear,
          termCode: selectedTermCode,
          entityType: type,
          userRole: this.userRole
        }
        let response = await this.addToMyStream(params)
        if (response) {
          if (isCoCurricular) {
            await this.populateAllStreamCourses({streamUuid: this.uuid, updateTimeStamp: true})
          }
          return this.notifySuccess('Successfully added "' + entity.title + '" in your stream.')
        } else {
          return this.notifyFailure('Error: Unable to add \'' + entity.title + '\' to your stream.')
        }
      },

      async addEntityListToStream (selectedEntities) {
        if (!selectedEntities || !selectedEntities.length) {
          return
        }
        let addEntityToStream = this.addEntityToStream
        await selectedEntities.forEach(entity => {
          addEntityToStream(entity, false)
        })
      },

      async addEntitiesToStreamClicked () {
        this.$refs.loadingModal.show()
        if ((this.planStreamSearchType === this.OTHER_SEARCH) && (!this.selectedTermCode || !this.selectedTermCode.length)) {
          this.selectedTermCode = this.selectedSearchIndex.toUpperCase()
        }
        this.loadLogDashboardActivity({action: 'addOtherEntityToStream', page: 'planStream', link: 'add to stream'})

        let addEntityListToStream = this.addEntityListToStream
        let selectedEntities = [this.selectedCatalogs, this.selectedJobs, this.selectedClubs, this.selectedEvents]
        await selectedEntities.forEach(selectedEntityList => {
          addEntityListToStream(selectedEntityList)
        })
        this.clearSelectedObjects()
        // avoid any race conditions by forcing the vuex state update
        await this.populateAllStreamCourses({streamUuid: this.uuid, updateTimeStamp: true})
        // this.selectedTermCode = ''
        this.$forceUpdate()
        this.$refs.loadingModal.hide()
      },

      prevPage () {
        if (this.pageNumber >= 1 && (this.from - this.size) >= 0) {
          this.updatePageNumber(this.pageNumber - 1)
          this.updateFrom(this.from - this.size)
          this.executeSearch()
        }
      },

      nextPage () {
        if ((this.from + this.size) < this.total) {
          this.updatePageNumber(this.pageNumber + 1)
          this.updateFrom(this.from + this.size)
          this.executeSearch()
        }
      },

      isFirstPage () {
        this.first = this.pageNumber <= 1
        return this.first
      },

      isLastPage () {
        this.last = (this.from + this.size) >= this.total
        return this.last
      },

      firstPage () {
        this.updatePageNumber(1)
        this.updateFrom(0)
        this.executeSearch()
      },

      lastPage () {
        if (this.total <= this.size) {
          return
        }
        let pageCounter = 1
        let fromCounter = 0
        while (fromCounter < (this.total - this.size)) {
          pageCounter += 1
          fromCounter += this.size
        }
        this.updatePageNumber(pageCounter)
        this.updateFrom(this.total - this.size)
        this.executeSearch()
      },

      hasCourses (stream) {
        return stream.courses && stream.courses.length > 0
      },

      goToCalendarView (substream) {
        this.loadLogDashboardActivity({action: 'checkSchedule', page: 'planStream', link: 'check schedule'})
        let streamUuid = this.uuid
        let currentSemester = (substream && substream.title) ? substream.title.split(' ')[0] : this.currentSemester
        let currentYear = (substream && substream.title) ? substream.title.split(' ')[1] : this.currentYear
        this.updateSearchAcademicYear({academicYear: substream.academicYear})
        const params = {
          streamUuid: streamUuid,
          currentYear: currentYear,
          currentSemester: currentSemester,
          isPlanningStream: true
        }
        return this.$router.push({ name: 'semesterCalendarView', params: params })
      },

      courseSearchTabClicked () {
        return this.setPlanStreamSearchType(this.COURSE_SEARCH)
      },

      catalogSearchTabClicked () {
        return this.setPlanStreamSearchType(this.CATALOG_SEARCH)
      },

      otherEntitiesSearchTabClicked () {
        this.setPlanStreamSearchType(this.OTHER_SEARCH)
        if (!this.selectedSearchIndex || !this.selectedSearchIndex.length) {
          this.selectedSearchIndex = 'job'
        }
      },

      isAddingEntity () {
        // NOTE: courses are intentionally excluded because the term information already selected
        let catalogs = this.selectedCatalogs
        let jobs = this.selectedJobs
        let clubs = this.selectedClubs
        let events = this.selectedEvents
        let other = this.selectedOtherEntities
        if (!catalogs.length && !jobs.length && !clubs.length && !events.length && !other.length) {
          return false
        }
        return true
      },

      isAddingCourse () {
        let courses = this.selectedCourses
        if (courses || courses.length < 0) {
          return false
        }
        return true
      },

      getDisabledColor (isVerified) {
        return isVerified ? '#407c45' : '#8b1c08'
      }
    },

    computed: {
      ...mapState({
        'stream': state => state.stream.stream,
        'coursePlanningStream': state => state.semester.coursePlanningStream,
        'enabledFeatures': state => state.institution.enabledFeatures,
        'planningTermCode': state => state.advancedSearch.planningTermCode,
        'termCode': state => state.advancedSearch.termCode,
        'academicYear': state => state.advancedSearch.academicYear,
        'packages': state => state.institution.packages,
        'institution': state => state.institution.institution,
        'permission': state => state.user.permission,
        'semesterCourses': state => state.semester.courses,
        'query': state => state.advancedSearch.query,
        'results': state => state.advancedSearch.results,
        'catalogResults': state => state.advancedSearch.catalogResults,
        'otherEntityResults': state => state.advancedSearch.otherEntityResults,
        'sort': state => state.advancedSearch.sort,
        '_source': state => state.advancedSearch._source,
        'from': state => state.advancedSearch.from,
        'size': state => state.advancedSearch.size,
        'pageNumber': state => state.advancedSearch.pageNumber,
        'facets': state => state.advancedSearch.facets,
        'catalogFacets': state => state.advancedSearch.catalogFacets,
        'terms': state => state.advancedSearch.terms,
        'department': state => state.advancedSearch.department,
        'subject': state => state.advancedSearch.subject,
        'division': state => state.advancedSearch.division,
        'instructor': state => state.advancedSearch.instructor,
        'major': state => state.advancedSearch.major,
        'unit': state => state.advancedSearch.unit,
        'qr': state => state.advancedSearch.qr,
        'monday': state => state.advancedSearch.monday,
        'tuesday': state => state.advancedSearch.tuesday,
        'wednesday': state => state.advancedSearch.wednesday,
        'thursday': state => state.advancedSearch.thursday,
        'friday': state => state.advancedSearch.firstyear,
        'classTimeFrom': state => state.advancedSearch.classTimeFrom,
        'classTimeTo': state => state.advancedSearch.classTimeTo,
        'firstyear': state => state.advancedSearch.firstyear,
        'lastUpdatedTime': state => state.advancedSearch.lastUpdatedTime,
        'semester': state => state.advancedSearch.semester,
        'total': state => state.advancedSearch.total,
        'catalogTotal': state => state.advancedSearch.catalogTotal,
        'publicLibraryList': state => state.advancedSearch.publicLibraryList,
        'privateLibraryList': state => state.advancedSearch.privateLibraryList,
        'libraryPositionMapping': state => state.search.libraryPositionMapping,
        'semesterCodeMap': state => state.advancedSearch.semesterCodeMap,
        'planStreamSearchType': state => state.stream.planStreamSearchType
      }),
      isOwner () {
        return (this.userId === this.stream.ownerId)
      },
      showAddCourseToStreamButton () {
        let courses = this.selectedCourses
        let showTermSelect = this.showTermSelect
        return !showTermSelect && courses.length && courses.length > 0
      },
      showAddEntityToStreamButton () {
        let jobs = this.selectedJobs
        let clubs = this.selectedClubs
        let events = this.selectedEvents
        return ((jobs.length && jobs.length > 0) || (clubs.length && clubs.length > 0) || (events.length && events.length > 0)) && this.otherEntitySelectedValue
      },
      showTermSelect () {
        let courses = this.selectedCourses
        let catalogs = this.selectedCatalogs
        let jobs = this.selectedJobs
        let clubs = this.selectedClubs
        let events = this.selectedEvents
        return !courses.length && (catalogs.length || jobs.length || clubs.length || events.length)
      },
      isPlanStreamCatalogsEnabled () {
        let planStreamCatalogs = this.enabledFeatures[PACKAGE.FEATURE_IDS.PLAN_STREAM_CATALOGS_FEATURE_ID]
        if (planStreamCatalogs && planStreamCatalogs.enabled) {
          return true
        }
        return false
      },
      planStreamCatalogsLabel () {
        let planStreamCatalogs = this.enabledFeatures[PACKAGE.FEATURE_IDS.PLAN_STREAM_CATALOGS_FEATURE_ID]
        if (!planStreamCatalogs || !planStreamCatalogs.label) {
          return 'Catalog Courses'
        }
        return planStreamCatalogs.label
      },
      isPlanStreamOtherEntitiesEnabled () {
        let planStreamOtherEntities = this.enabledFeatures[PACKAGE.FEATURE_IDS.PLAN_STREAM_OTHER_ENTITIES_FEATURE_ID]
        if (planStreamOtherEntities && planStreamOtherEntities.enabled) {
          return true
        }
        return false
      },
      planStreamOtherEntitiesLabel () {
        let planStreamOtherEntities = this.enabledFeatures[PACKAGE.FEATURE_IDS.PLAN_STREAM_OTHER_ENTITIES_FEATURE_ID]
        if (!planStreamOtherEntities || !planStreamOtherEntities.label) {
          return 'Other Entities'
        }
        return planStreamOtherEntities.label
      },
      isPlannerViewEnabled () {
        let plannerViewFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.PLANNER_VIEW_FEATURE_ID]
        if (plannerViewFeature && plannerViewFeature.enabled) {
          return true
        }
        return false
      },
      semesters () {
        let semesterMap = this.semesterMap
        if (!semesterMap) {
          return []
        }
        if (this.planStreamSearchType === this.OTHER_SEARCH) {
          semesterMap = this.otherEntitiesSemesterMap
        }
        let semesters = []
        let ALL_TERMS_CODE = this.ALL_TERMS_CODE
        Object.keys(semesterMap).sort().forEach(semesterCode => {
          if (semesterCode !== ALL_TERMS_CODE) {
            semesters.push({
              academicTerm: semesterMap[semesterCode],
              termCode: semesterCode
            })
          }
        })
        return semesters
      },
      semesterMap () {
        let institution = this.institution
        if (!institution || !institution.semesterMap) {
          return {}
        }
        return institution.semesterMap
      },
      planningSubStreams () {
        let planningSubStreams = []
        let semesterMap = this.semesterMap
        let coursePlanningStream = this.coursePlanningStream

        let COURSE = this.COURSE
        let CATALOG = this.CATALOG
        let JOB = this.JOB
        let CLUB = this.CLUB
        let EVENT = this.EVENT
        Object.keys(coursePlanningStream).sort().forEach((key, i) => {
          let substream = coursePlanningStream[key]
          let formattedCourses = []
          let formattedCatalogs = []
          let formattedJobs = []
          let formattedClubs = []
          let formattedEvents = []
          let substreamLabel = key
          let planningTermCode
          substream.forEach(planningTerm => {
            planningTermCode = planningTerm.termCode
            substreamLabel = semesterMap[planningTermCode] || substreamLabel
            let hasConflict = false
            let status = planningTerm.status
            let startDate = planningTerm.startDate
            let endDate = planningTerm.endDate
            let verified = planningTerm.verified
            let notifyAdvisor = planningTerm.notifyAdvisor

            if (planningTerm.course) {
              let course = planningTerm.course
              course.meetingDaysFormatted.forEach((meetingDay) => {
                if (meetingDay.conflict) {
                  hasConflict = true
                }
              })
              let formattedCourse = {
                uuid: course.uuid,
                title: course.title,
                type: COURSE,
                termCode: planningTermCode,
                block: planningTerm.block, // course.block ? course.block.join(', ') : '',
                hasConflict: hasConflict,
                courseData: course
              }
              formattedCourses.push(formattedCourse)
            }
            if (planningTerm.catalog) {
              let catalog = planningTerm.catalog
              let formattedCatalog = {
                uuid: catalog.uuid,
                title: catalog.title,
                type: CATALOG,
                termCode: planningTermCode,
                catalogData: catalog
              }
              formattedCatalogs.push(formattedCatalog)
            }
            if (planningTerm.job) {
              let job = planningTerm.job
              let formattedJob = {
                uuid: job.uuid,
                title: job.title,
                type: JOB,
                termCode: planningTermCode,
                jobData: job,
                status: status,
                startDate: startDate,
                endDate: endDate,
                notifyAdvisor: notifyAdvisor,
                verified: verified
              }
              formattedJobs.push(formattedJob)
            }
            if (planningTerm.club) {
              let club = planningTerm.club
              let formattedClub = {
                uuid: club.uuid,
                title: club.title,
                type: CLUB,
                termCode: planningTermCode,
                clubData: club,
                status: status,
                startDate: startDate,
                endDate: endDate,
                notifyAdvisor: notifyAdvisor,
                verified: verified
              }
              formattedClubs.push(formattedClub)
            }
            if (planningTerm.event) {
              let eventObject = planningTerm.event
              let formattedEvent = {
                uuid: eventObject.uuid,
                title: eventObject.title,
                type: EVENT,
                termCode: planningTermCode,
                eventData: eventObject,
                status: status,
                startDate: startDate,
                endDate: endDate,
                notifyAdvisor: notifyAdvisor,
                verified: verified
              }
              formattedEvents.push(formattedEvent)
            }
          })
          let academicYear = key.includes('_') ? key.split('_')[0] : ''
          let planningSubStream = {
            title: substreamLabel,
            courses: formattedCourses,
            catalogs: formattedCatalogs,
            jobs: formattedJobs,
            clubs: formattedClubs,
            events: formattedEvents,
            termCode: planningTermCode,
            academicYear: academicYear
          }
          planningSubStreams.push(planningSubStream)
        })
        // NOTE: force a vuex update everytime an object is removed
        this.courseToRemove = this.courseToRemove || {}
        this.catalogToRemove = this.catalogToRemove || {}
        this.jobToRemove = this.jobToRemove || {}
        this.clubToRemove = this.clubToRemove || {}
        this.eventToRemove = this.eventToRemove || {}

        return planningSubStreams
      },
      currentTermCode () {
        return this.courseToRemove ? this.courseToRemove.termCode : ''
      },
      currentSemester () {
        if (!this.currentTermCode) {
          return ''
        }
        return this.semesterMap[this.currentTermCode].split(' ')[0]
      },
      currentYear () {
        if (!this.currentTermCode) {
          return ''
        }
        return this.semesterMap[this.currentTermCode].split(' ')[1]
      },
      addToStreamFlagMap () {
        let featureId = PACKAGE.FEATURE_IDS.ADD_TO_STREAM_FEATURE_ID
        let coursePlanningPackage = this.getCoursePlanningPackage()
        return PackageUtil.getFlagsFromPackageFeature(coursePlanningPackage, featureId)
      },
      courseSearchFlagMap () {
        let featureId = PACKAGE.FEATURE_IDS.COURSE_SEARCH_FEATURE_ID
        let coursePlanningPackage = this.getCoursePlanningPackage()
        return PackageUtil.getFlagsFromPackageFeature(coursePlanningPackage, featureId)
      },
      scheduleCheckFeatureMap () {
        let featureId = PACKAGE.FEATURE_IDS.SCHEDULE_CHECK_FEATURE_ID
        let coursePlanningPackage = this.getCoursePlanningPackage()
        return PackageUtil.getFeatureFromPackage(coursePlanningPackage, featureId)
      },
      scheduleCheckFlagMap () {
        let featureId = PACKAGE.FEATURE_IDS.SCHEDULE_CHECK_FEATURE_ID
        let coursePlanningPackage = this.getCoursePlanningPackage()
        return PackageUtil.getFlagsFromPackageFeature(coursePlanningPackage, featureId)
      },
      isScheduleCheckEnabled () {
        let isNotAdvisor = this.userRole !== this.ADVISOR_ROLE
        let scheduleCheckFeatureMap = this.scheduleCheckFeatureMap
        return isNotAdvisor && scheduleCheckFeatureMap && scheduleCheckFeatureMap.enabled === true
      },
      formattedSource () {
        let planStreamSearchType = this.planStreamSearchType
        if (planStreamSearchType === this.CATALOG_SEARCH) {
          return this.catalogSource
        }
        if (planStreamSearchType === this.OTHER_SEARCH) {
          return this.otherEntitiesSource
        }

        // default to COURSE SEARCH source
        let source = [
          'uuid',
          'title',
          'description',
          'creationTime',
          'lastUpdatedTime',
          'type',
          'ancestor',
          'owningLibraryId',
          'ownerName',
          'ownerId',
          'originUuid',
          'thumbnailURIList',
          'appliedTagMap',
          'facetedCourseTags',
          'prerequisites',
          'corequisities',
          'catalogCourseId',
          'level',
          '_score'
        ]
        let flagMap = this.courseSearchFlagMap
        if (!flagMap) {
          return source
        }

        if (flagMap.showEnrollmentOnResult) {
          source.push('maxSeats')
          source.push('currentSeats')
        }
        if (flagMap.showRoomInformationOnResult) {
          source.push('roomInformation')
        }
        if (flagMap.showMeetingDaysOnResult) {
          source.push('meetingDays')
          source.push('meetingDaysRaw')
          source.push('meetingDaysFormatted')
        }
        if (flagMap.showMeetingTimesOnResult) {
          source.push('meetingFromTime')
          source.push('meetingToTime')
        }
        if (flagMap.showSpecialInstructionsOnResult) {
          source.push('specialInstructions')
        }
        if (flagMap.showCRNOnResult) {
          source.push('crn')
        }
        if (flagMap.showDivisionCriteria) {
          source.push('division')
        }
        if (flagMap.showDepartmentCriteria) {
          source.push('department')
          source.push('departmentCode')
        }
        if (flagMap.showSubjectCriteria) {
          source.push('subject')
          source.push('subjectCode')
        }
        if (flagMap.showUnitsCriteria) {
          source.push('maxCredit')
          source.push('minCredit')
          source.push('creditHour')
        }
        if (flagMap.showInstructorCriteria) {
          source.push('instructorNames')
        }
        if (flagMap.showSectionOnResult) {
          source.push('num')
        }
        if (flagMap.showSemesterCriteria) {
          source.push('termCode')
          source.push('term')
          source.push('academicTerm')
        }
        if (flagMap.showTimeCriteria) {
          source.push('timeSlots')
        }
        if (flagMap.showCourseSearchFlagCriteria) {
          source.push('courseFlags')
        }
        if (flagMap.showMajorsCriteria) {
          source.push('courseMajors')
          source.push('courseMajorCodes')
        }
        if (flagMap.showBlockCriteria) {
          source.push('block')
        }
        if (flagMap.showGradeLevelCriteria) {
          source.push('gradeLevel')
        }
        if (flagMap.showYearCriteria) {
          source.push('academicYear')
        }
        return source
      },
      formattedIndexList () {
        let allIndices = []
        let planStreamSearchType = this.planStreamSearchType
        if (planStreamSearchType === this.COURSE_SEARCH) {
          allIndices = this.courseSearchIndexes
        }
        if (planStreamSearchType === this.CATALOG_SEARCH) {
          allIndices = this.catalogSearchIndexes
        }
        if (planStreamSearchType === this.OTHER_SEARCH) {
          allIndices = [this.selectedSearchIndex]
        }
        return this.joinListWithCommas(allIndices)
      },
      formattedLibraryList () {
        let allFolders = this.allFolders
        return this.joinListWithCommas(allFolders)
      },
      formattedCourseResults () {
        let formatted = []
        let results = this.results
        if (!results || results.length <= 0) {
          return []
        }
        let formatDayAndTime = this.getFormattedDayAndTimeStrings
        let isCourseInStream = this.isCourseInStream
        results.forEach(function (result) {
          let dayAndTimeStrings = formatDayAndTime(result)
          result['uuid'] = result.uuid
          result['section'] = '#' + result['num']
          result['days'] = dayAndTimeStrings['days']
          result['times'] = dayAndTimeStrings['times']
          result['enrollment'] = result['currentSeats'] + '/' + result['maxSeats']
          if (isCourseInStream(result)) {
            result['isAddedToStream'] = true
          } else {
            result['isAddedToStream'] = false
          }
          formatted.push(result)
        })
        return formatted
      },
      formattedCatalogResults () {
        let formatted = []
        let results = this.catalogResults // TODO
        if (!results || results.length <= 0) {
          return formatted
        }
        let formatDayAndTime = this.getFormattedDayAndTimeStrings
        results.forEach(function (result) {
          let dayAndTimeStrings = formatDayAndTime(result)
          result['section'] = '#' + result['num']
          result['days'] = dayAndTimeStrings['days']
          result['times'] = dayAndTimeStrings['times']
          result['enrollment'] = result['currentSeats'] + '/' + result['maxSeats']
          result['isAddedToStream'] = false
          formatted.push(result)
        })
        return formatted
      },
      formattedOtherEntitiesResults () {
        let formatted = []
        let results = this.otherEntityResults
        if (!results || results.length <= 0) {
          return formatted
        }
        results.forEach(result => {
          if (this.isEntityInStream(result, result.index)) {
            result['isAddedToStream'] = true
          } else {
            result['isAddedToStream'] = false
          }
          formatted.push(result)
        })
        return formatted
      },
      closeIcon () {
        return 'x'
      },
      isShowFilterIcon () {
        return (this.planStreamSearchType !== this.OTHER_SEARCH)
      }
    },

    watch: {
      lastUpdatedTime (newTime, oldTime) {
        // this.showLoader()
        // this.initializeSearchFilter()
        // let shouldUpdateFacets = true
        // this.executeSearch(shouldUpdateFacets)
      },
      uuid (newId) {
        // this.streamIndex = this.calculateStartIndex()
        // this.clearCourses()
        // return this.populateAllStreamCourses({streamUuid: newId})
      },
      selectedSearchIndex (newVal) {
        if (newVal && newVal.length > 0) {
          this.selectedJobs = []
          this.selectedClubs = []
          this.selectedEvents = []
          this.otherEntitySelectedValue = null
          this.selectedTermCode = newVal.toUpperCase()
          this.doOtherEntitiesSearch()
        }
      }
    }
  }
</script>
<style>
  .jumbotron {
    background: #fffff;
  }
  .text-center {
    text-align: center;
  }
  .bg-gray{
    min-height: 400px;
  }
  .catalog-stream-style {
    color: #bf526f;
  }
</style>



// WEBPACK FOOTER //
// src/app/stream/components/PlanStream.vue